import React, { useEffect } from 'react';
import { Form, Input, Modal } from '@maxtropy/components';
import { apiV2PeriodSavePost, apiV2PeriodUpdatePost } from '@maxtropy/device-customer-apis-v2';
import { PeriodItem } from '..';

interface Props {
  period?: PeriodItem;
  modalVisible?: boolean;
  setModalVisible: (v: boolean) => void;
  forceUpdate?: () => void;
}
const AddPeriodModal: React.FC<Props> = ({ period, modalVisible, setModalVisible, forceUpdate }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (period) {
      form.setFieldValue('name', period.name);
    }
  }, [period]);

  const onOk = () => {
    form.validateFields().then(values => {
      if (period) {
        apiV2PeriodUpdatePost({ name: values.name, id: period.id }).then(res => {
          setModalVisible(false);
          forceUpdate?.();
        });
      } else {
        apiV2PeriodSavePost({ name: values.name }).then(res => {
          setModalVisible(false);
          forceUpdate?.();
        });
      }
    });
  };

  const onCancel = () => {
    form.resetFields();
    setModalVisible?.(false);
  };

  return (
    <Modal
      contentClassName="modal-form-content"
      open={modalVisible}
      title="新增数据查询时段"
      onCancel={onCancel}
      onOk={onOk}
      destroyOnClose
    >
      <Form form={form}>
        <Form.Item label="数据查询时段名称" name="name" rules={[{ required: true, min: 2, max: 30 }]}>
          <Input placeholder="请输入" allowClear />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddPeriodModal;
